import { purchaseOrders } from "@/api/purchaseOrder/usePurchaseOrder";
import { useModal } from "@/features/modal/ModalStackManager";
import { PurchaseOrderItemsCreateForm } from "@/features/purchaseOrderItems/form/createForm";
import { ActionButtonBox } from "@/features/standard/ActionButtonBox";
import { ActionHeader } from "@/features/standard/ActionHeader";
import { Main } from "@/features/standard/Main";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { LeftSpace } from "@/features/standard/detail/LeftSpace";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { useUserStore } from "@/store/userStore";
import { getUserCodeByUser } from "@/utils/checkData";
import { translateWithPartnerType } from "@/utils/partnerType";
import { Button, Flex, Tabs } from "@mantine/core";
import {
  AuthSignupPost201ResponseEquipmentPurchaseOrderItem,
  ItemsGet200ResponseRowsInnerLotsInnerInventoriesInner,
} from "@sizlcorp/sizl-api-document/dist/models";
import { IconPlus } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PurchaseOrderDetailActionBar } from "../header/purchaseOrderDetailActionBar";
import { PurchaseOrderDetailHeader } from "../header/purchaseOrderDetailHeader";
import { PurchaseOrderDetailTable } from "../table/purchaseOrderDetailTable";

const Detail = Object.assign({}, Main, {
  Container: DetailContainer,
  Wrapper: DetailWrapper,
  Content: DetailContent,
  ActionBar: PurchaseOrderDetailActionBar,
  ActionHeader: ActionHeader,
  ActionButtonBox: ActionButtonBox,
  ActionButton: Button,
  PurchaseOrderItemsCreateForm: PurchaseOrderItemsCreateForm,
});

interface PurchaseOrderDetailFormProps {
  purchaseOrderId: number;
}

export const PurchaseOrderDetailForm = (params: PurchaseOrderDetailFormProps) => {
  const { purchaseOrderId } = params;
  const { t } = useTranslation();
  const { userInfo } = useUserStore();
  const partnerType = userInfo?.partner?.type;
  // TODO: 삭제된 purchaseOrderId일 때 삭제되었음을 표시하였으나 오류는 여전히 발생함. 처리 필요
  const { data: purchaseData } = useQuery(
    purchaseOrders.detail({
      purchaseOrderId: purchaseOrderId,
      populate: ["location", "user", "partner", "purchaseOrderItems"],
    })
  );
  const userCode = getUserCodeByUser();
  const { openModal } = useModal();
  const [isRowBtnActive, setIsRowBtnActive] = useState<boolean>(false);
  const [selectedRowsInform, setSelectedRowsInform] = useState<
    ItemsGet200ResponseRowsInnerLotsInnerInventoriesInner[]
  >([]);
  const [data, setData] = useState<
    AuthSignupPost201ResponseEquipmentPurchaseOrderItem[] | undefined
  >();

  const handleRowSelect = (selectedRows: any, formatterPropsData: any) => {
    setIsRowBtnActive(selectedRows.size === 1);
    setData(formatterPropsData);
    setSelectedRowsInform(selectedRowsInform);
  };

  return (
    <Flex w="100%" h="100%">
      {purchaseData && (
        <Detail.Container>
          <Detail.ActionBar data={purchaseData?.data} />
          <Detail.Wrapper>
            <Detail.Content>
              {/* <PurchaseOrderDetailDataHeader /> */}
              <PurchaseOrderDetailHeader data={purchaseData?.data} />
              <Tabs defaultValue="purchaseOrder">
                <LeftSpace />
                <Tabs.List>
                  <Tabs.Tab value="purchaseOrder">
                    {translateWithPartnerType(
                      t,
                      "purchaseOrderItems.purchaseOrderItems",
                      partnerType
                    )}
                  </Tabs.Tab>
                  {/* <Tabs.Tab value="history">{t("info.history")}</Tabs.Tab> */}
                </Tabs.List>
                <Tabs.Panel value="purchaseOrder">
                  <Flex direction={"column"} gap="md">
                    <Detail.ActionHeader>
                      <Detail.ActionButtonBox>
                        <Detail.ActionButton
                          leftIcon={<IconPlus />}
                          onClick={() =>
                            openModal(
                              <Detail.PurchaseOrderItemsCreateForm
                                purchaseOrderId={purchaseData?.data?.id}
                              />,
                              null,
                              t("common.additional", {
                                item: translateWithPartnerType(
                                  t,
                                  "purchaseOrderItems.purchaseOrderItems",
                                  partnerType
                                ),
                              })
                            )
                          }
                        >
                          {t("common.additional", {
                            item: translateWithPartnerType(
                              t,
                              "purchaseOrderItems.purchaseOrderItems",
                              partnerType
                            ),
                          })}
                        </Detail.ActionButton>
                        {/* <Detail.ActionButton
                          leftIcon={<IconPlus />}
                          color="orange"
                          disabled={data?.length === 0}
                          onClick={() =>
                            openModal(
                              <PurchaseOrderOutgoingForm purchaseOrderItems={data} />,
                              null,
                              t("delivery.delivery"),
                            )
                          }
                        >
                          {t("delivery.action")}
                        </Detail.ActionButton>
                        <Detail.ActionButton
                          leftIcon={<IconPlus />}
                          color="orange"
                          disabled={!(data?.length === 1)}
                          onClick={() =>
                            openModal(
                              <ArrivalDeliveryStockPlanForm formatterProps={data && data[0]} />,
                              null,
                              t("purchaseOrderItems.outgoing"),
                            )
                          }
                        >
                          {t("purchaseOrderItems.outgoing")}
                        </Detail.ActionButton>
                        <Detail.ActionButton
                          leftIcon={<IconPlus />}
                          color="orange"
                          disabled={!(data?.length === 1)}
                          onClick={() =>
                            openModal(
                              <ProductionPlanCreateForm formatterProps={data && data[0]} />,
                              null,
                              t("common.create", { item: t("productionPlan.productionPlan") }),
                              true,
                            )
                          }
                        >
                          {t("common.create", { item: t("productionPlan.productionPlan") })}
                        </Detail.ActionButton> */}
                      </Detail.ActionButtonBox>
                    </Detail.ActionHeader>
                    <PurchaseOrderDetailTable
                      onRowSelect={handleRowSelect}
                      purchaseOrderId={purchaseOrderId}
                    />
                  </Flex>
                </Tabs.Panel>
                <Tabs.Panel value="history">2</Tabs.Panel>
              </Tabs>
            </Detail.Content>
          </Detail.Wrapper>
        </Detail.Container>
      )}
    </Flex>
  );
};
